import React from 'react';
import { Button, Box } from '@material-ui/core';
import { TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import Modal, { ModalContents, ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { useRejectChapterRequestMutation } from 'generated/graphql';

export const RejectChapterRequestModal = ({
  onClose,
  id,
  open,
}: {
  open: boolean;
  id: string;
  onClose: () => void;
}) => {
  const {
    control,
    formState: { errors, touchedFields },
    getValues,
  } = useForm<{ rejectionReason: string }>({
    defaultValues: {
      rejectionReason: '',
    },
    mode: 'onChange',
  });

  const [rejectChapterRequest, { loading: rejecting }] = useRejectChapterRequestMutation();

  const handleConfirm = async () => {
    const { rejectionReason } = getValues();

    await rejectChapterRequest({
      variables: {
        id,
        reason: rejectionReason,
        hash: '',
      },
    });

    onClose();
  };

  return (
    <Modal open={open} fullWidth onClose={onClose}>
      <ModalContents
        onClickClose={onClose}
        body={
          <Box mb={4}>
            <ModalTitle>Reject Chapter Request</ModalTitle>
            <ModalTypography>Are you sure you want to reject this chapter request?</ModalTypography>
            <Controller
              name="rejectionReason"
              control={control}
              rules={{
                required: 'Please enter a reason for the chapter request rejection',
                maxLength: 300,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Rejection Reason"
                  fullWidth
                  required
                  variant="standard"
                  error={Boolean(errors.rejectionReason)}
                  helperText={
                    (touchedFields.rejectionReason && errors.rejectionReason?.message) ||
                    'Why is this chapter request being rejected?'
                  }
                />
              )}
            />
          </Box>
        }
        actions={
          <Button
            color="primary"
            type="button"
            variant="contained"
            onClick={handleConfirm}
            disabled={rejecting}
          >
            Confirm
          </Button>
        }
      />
    </Modal>
  );
};
